<!-- 充值页面 -->
  <template>
  <div>
    <div class="rechargebox">
      <div class="logobox">
        <h1 @click="gohome()" class="logo"></h1>
      </div>
      <p class="title1">Account to be recharged</p>
      <p class="txt1">Please check account information</p>
      <div class="inputs">
        <input :class="!checkuid?'noid':''" @focus="checkuid =true" v-model="uid" placeholder="Please enter your Mango ID" type="text">
        <button @click="Userinfo()">Check</button>
      </div>
      <div v-if="userinfo.uid" class="userinfo">
        <img :src="userinfo.head" alt="">
        <p>
          <span>{{userinfo.name}}</span>
          <span>ID: {{userinfo.uid}}</span>
        </p>
      </div>

      <div class="dropdownbox">
        <p class="title">Country / Region</p>

        <el-select v-model="Indonesia_select" :change="countrychange()">
          <el-option v-for="item in options" :key="item.countryCode" :label="item.countryName" :value="item.countryCode">
          </el-option>
        </el-select>
      </div>
      <div class="methodbox">
        <p class="title">Recharge method </p>
        <div class="method_btns">
          <button v-for="(item,index ) in method_btn" :key="index" @click="handleMethos(item,index) " :class="method_btnindex==index?'active':'' ">{{item}}</button>
          <!-- <button>Dana</button>
            <button>Linkaja</button> -->
        </div>
        <div v-if="needMobile" class="mobile-shell">
          <span>+62</span>
          <input class="mobile" v-model="mobile" type="text" placeholder="please fill in your Phone number for payment" />
        </div>
      </div>
      <div class="quantitybox">
        <p class="title">Recharge quantity <span class="Please_txt"></span></p>
        <ul>
          <li @click="cataLogDataindex =index " v-for="(item,index) in cataLogData[method_btn[method_btnindex]]" :key="index" :class="cataLogDataindex==index?'active':'' ">
            <span>{{item.amount}} Diamonds</span> <span>{{item.price}} {{item.priceUnit}}</span>
          </li>

        </ul>
      </div>
      <button @click="openRecharge" class="Rechargebtn">Recharge</button>

      <div class="link">
        <ul>
          <li><img src="@/assets/images/link/1.png" alt=""></li>
          <li><img src="@/assets/images/link/2.png" alt=""></li>
          <li><img src="@/assets/images/link/3.png" alt=""></li>
          <li><img src="@/assets/images/link/4.png" alt=""></li>
          <li><img src="@/assets/images/link/5.png" alt=""></li>
          <li><img src="@/assets/images/link/6.png" alt=""></li>
          <li><img src="@/assets/images/link/7.png" alt=""></li>
          <li><img src="@/assets/images/link/8.png" alt=""></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// import Clipboard from 'clipboard';
export default {
  data() {
    return {
      uid: "", //17583910
      isuid: false, // 有UID
      checkuid: true, //校验UID
      userinfo: {
        uid: "",
      }, //
      Indonesia_select: " ",
      Indonesiasel: " ",
      options: [],
      delOptions: [62, 60, 84, 65, 66, 63], 
      method_btn: [],
      method_btnindex: 0,
      cataLogData: {},
      cataLogDataindex: 0,
      needMobile: false,
      mobile: "",
    };
  },
  created() {
    this.arealist();
    //  this.cataloglist()
  },

  methods: {
    handleMethos(item, index) {
      if (!this.method_btn.length) return;
      this.method_btnindex = index;
      let arr = ["ovo", "linkaja"].map((item) => item.toLocaleUpperCase());

      let methodIndex = arr.findIndex(
        (value) => item.toLocaleUpperCase() == value.toLocaleUpperCase()
      );
      if (methodIndex < 0) {
        this.needMobile = false;
      } else {
        this.needMobile = true;
      }
    },
    arealist() {
      var _this = this;
      _this.$http.post(_this.$api.arealist).then(function (response) {
        response.data.data.forEach((value) => {
          if (!_this.delOptions.find((item) => value.countryCode == item)) {
            _this.options.push(value);
          }
          //
        }); 
        _this.Indonesia_select = _this.options[0].countryCode;
        _this.Indonesiasel = _this.options[0].countryCode;

        setTimeout(() => {
          _this.cataloglist();
        }, 100);
      });
    },
    cataloglist() {
      var _this = this;
      var code = _this.Indonesia_select;
      _this.$http
        .post(_this.$api.cataloglist, { countryCode: code })
        .then(function (response) {
          var _data = response.data.data.cataLogData;
          _this.method_btn = Object.keys(_data);
          _this.handleMethos(_this.method_btn[0], 0);
          _this.cataLogData = _data;
        });
    },
    Userinfo() {
      var _this = this;
      if (_this.uid == "") {
        _this.$message({
          customClass: "h5msg",
          type: "error",
          message: "Please enter your Mango ID",
        });
        return;
      }

      _this.$http
        .post(_this.$api.userinfo, { uid: _this.uid })
        .then(function (response) {
          console.log(response);
          if (response.data.code == "S_OK") {
            _this.userinfo = response.data.data;
            _this.isuid = true;
            _this.checkuid = true;
          } else {
            _this.checkuid = false;
            _this.isuid = false;
            _this.userinfo = "";
            _this.$message({
              customClass: "h5msg",
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    countrychange(data) {
      var _this = this;
      console.log(_this.Indonesia_select);
      if (_this.Indonesia_select == _this.Indonesiasel) {
        return;
      } else {
        setTimeout(() => {
          _this.cataloglist();
          _this.Indonesiasel = _this.Indonesia_select;
        });
      }
    },
    openRecharge() {
      var _this = this;
      if (!_this.isuid) {
        _this.checkuid = false;
        _this.$message({
          customClass: "h5msg",
          type: "error",
          message: "Please enter your Mango ID and click 【Check】",
        });
        return;
      }
      if (
        ["OVO", "LINKAJA"].findIndex(
          (value) =>
            value ===
            _this.method_btn[_this.method_btnindex].toLocaleUpperCase()
        ) > -1 &&
        !_this.mobile
      ) {
        return message("please fill in your Phone number for payment");
      }
      var data = _this.cataLogData[_this.method_btn[_this.method_btnindex]];
      _this
        .$confirm(
          "Are you sure to recharge " +
            data[_this.cataLogDataindex].amount +
            " diamonds?",
          {
            confirmButtonText: "Sure",
            cancelButtonText: "Cancel",
            customClass: "h5confirm",
          }
        )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            customClass: "h5Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          _this.$http
            .post(_this.$api.docharge, {
              catalogCode: data[_this.cataLogDataindex].catalogCode,
              countryCode: data[_this.cataLogDataindex].countryCode,
              uid: _this.uid,
              mobile: _this.mobile && "+62" + _this.mobile,
            })
            .then(function (response) {
              console.log(response);
              loading.close();
              if (response.data.code == "S_OK") {
                if (
                  _this.method_btn[_this.method_btnindex].toLocaleUpperCase() ==
                  "OVO"
                ) {
                  return _this.$message({
                    customClass: "h5msg",
                    message: `The order has been created, please check your OVO Application and continued the process of
                payment.`,
                  });
                }
                window.location.href = response.data.data.url;
                loading.close();
              } else {
                _this.$message({
                  customClass: "h5msg",
                  type: "error",
                  message: response.data.message,
                });
              }
            });
        })
        .catch(() => {});
    },
    gohome() {
      this.$router.push({ path: "/h5home" });
    },
  },
};
</script>
<style lang="less" scoped>
.el-select-dropdown{
  height: 100px;
}
.mobile-shell {
  margin-top: 0.3rem;
  width: 860px;
  height: 120px;
  position: relative;
  span {
    position: absolute;
    font-size: 0.36rem;
    top: 50%;
    transform: translateY(-51%);
    left: 10px;
  }
  .mobile {
    width: 860px;
    height: 120px;
    background: #f8f8f8;
    border-radius: 32px;
    font-size: 0.36rem;
    box-sizing: border-box;
    padding: 0 100px;
  }
}

.rechargebox {
  width: 100%;
  padding: 0 0.67rem 2rem 0.67rem;
  box-sizing: border-box;
}
.logobox {
  padding: 0.8rem 0rem;
  box-sizing: border-box;
  .logo {
    width: 3.46rem;
    height: 2.9rem;
    background: url("../../assets/images/liveimg/LaunchLOGO.png");
    background-size: 100% 100%;
  }
}
.title1 {
  font-size: 0.4rem;
  font-weight: bold;
  color: rgba(48, 48, 48, 1);
  margin-bottom: 0.27rem;
}
.txt1 {
  font-size: 0.32rem;
  font-weight: 400;
  color: rgba(160, 160, 160, 1);
}
.inputs {
  padding: 0.54rem 0rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  input {
    width: 78%;
    background: rgba(248, 248, 248, 1);
    border-radius: 0.2rem;
    height: 0.8rem;
    padding: 0 0.27rem;
    box-sizing: border-box;
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(160, 160, 160, 1);
  }
  .noid {
    border: 1px solid rgba(237, 72, 72, 1);
    color: rgba(237, 72, 72, 1);
  }
  .noid::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(237, 72, 72, 1);
  }

  button {
    width: 19%;
    height: 0.8rem;
    border-radius: 0.2rem;
    background: -webkit-linear-gradient(270deg, #7df670 0%, #1cee98 100%);
    background: linear-gradient(270deg, #7df670 0%, #1cee98 100%);
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
.userinfo {
  background: url("../../assets/images/liveimg/phoneID@2x.png");
  background-size: 100% 100%;
  padding: 0 0.4rem;
  box-sizing: border-box;
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  align-items: center;
  height: 1.6rem;
  margin-bottom: 1rem;
  img {
    width: 1.07rem;
    height: 1.07rem;
    border-radius: 50%;
  }
  p {
    display: flex;
    flex-direction: column;
    margin-left: 0.4rem;
    color: #a0a0a0;
    font-size: 0.27rem;
    span:nth-child(1) {
      color: #303030;
      font-weight: bold;
      font-size: 0.37rem;
      margin-bottom: 0.05rem;
    }
  }
}
.title {
  font-size: 0.4rem;
  font-weight: bold;
  color: rgba(48, 48, 48, 1);
  .Please_txt {
    font-size: 0.27rem;
    font-weight: 400;
    color: rgba(255, 50, 63, 1);
  }
}
.dropdownbox {
  display: flex;
  justify-content: space-between;

  .el-select {
    color: rgba(48, 48, 48, 1);
    width: 2.5rem;
    height: 0.6rem;
    font-size: 0.27rem;
    background: #fff;
    border: 1px solid rgba(185, 67, 255, 1);
    border-radius: 0.2rem;
  }
}
.el-select-dropdown__item {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  color: rgba(48, 48, 48, 1);
  font-size: 0.27rem;
}
.methodbox {
  margin-top: 1rem;
  .method_btns {
    display: flex;
    margin-top: 0.2rem;
    flex-wrap: wrap;
    justify-content: space-between;
    button {
      width: 48%;
      margin-top: 0.3rem;
      padding: 0 0.05rem;
      color: rgba(48, 48, 48, 1);
      height: 0.97rem;
      font-size: 0.32rem;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.2rem;
    }
    .active {
      background: rgba(125, 246, 112, .32);
      color: #000;
      border: 0.04rem solid #1cee98;
    }
  }
}
.quantitybox {
  margin-top: 1rem;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.3rem;
      padding: 0 0.4rem;
      box-sizing: border-box;
      font-size: 0.32rem;
      color: rgba(48, 48, 48, 1);
      width: 100%;
      height: 1.07rem;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.2rem;
      border: 0.01rem solid rgba(0, 0, 0, 0);
      span:nth-child(2) {
        font-weight: bold;
      }
    }
    .active {
      // background: -webkit-linear-gradient(270deg, #7df670 0%, #1cee98 100%);
      // background: linear-gradient(270deg, #7df670 0%, #1cee98 100%);
      background: rgba(125, 246, 112, .32);
      color: #000;
      border: 0.04rem solid #1cee98;
    }
  }
}
.Rechargebtn {
  display: block;
  margin: 0.8rem auto 0 auto;
  width: 5.34rem;
  font-size: 0.4rem;
  height: 1.07rem;
  color: rgba(255, 255, 255, 1);
  background: -webkit-linear-gradient(270deg, #7df670 0%, #1cee98 100%);
  background: linear-gradient(270deg, #7df670 0%, #1cee98 100%);
  border-radius: 1rem;
}

.noactive {
  background: rgba(255, 239, 239, 1);
  border: 1px solid rgba(237, 72, 72, 1);
  color: #ed4848;
}
.link {
  width: 100%;
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
  }
  li {
    width: 23%;
    margin: 0.1rem 0 0 0.1rem;
    justify-content: center;
    // border-radius: 10px;
    // overflow: hidden;
    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5recharge.vue